<main class="container" *ngIf="trip_Obj?.iEmdadRo">
    <!-- پرداخت موفقیت آمیز -->
    <section *ngIf="trip_Obj.iResult == 1" class="success-container border-2 rounded p-md-3 px-2">
        <div class="alert alert-success w-100 d-flex align-items-center justify-content-center" role="alert">
            <span class="fw-bold mx-1 fs-6" style="line-height: 30px;"> {{ trip_Obj?.strMessage }} </span>
        </div>

        <!-- توضیحات -->

        <div class="alert alert-success w-100" role="alert">
            <p class="fw-bold mx-1 " style="font-size: 13px;">
                کد سفر : {{ trip_Obj.iEmdadRo || 'نامشخص' | faNum }}
            </p>
            <p class="fw-bold mx-1 " style="font-size: 13px;"> مبلغ پرداخت شده :
                {{ trip_Obj.iAmount | number: '1.0-0' |faNum}} ریال </p>
            <p class="fw-bold mx-1 " style="font-size: 13px;"> شماره تراکنش :
                {{ trip_Obj.strRefId || 'نامشخص' | faNum}}
                <i class="fa pointer" [ngClass]="bClipboard ? 'fa-check' : 'fa-clone' "
                    (click)="clipboard(trip_Obj.strRefId)">
                    {{ bClipboard ? 'کپی شد!' : '' }}
                </i>
            </p>
        </div>

    </section>

    <!-- پرداخت ناموفق -->
    <section *ngIf="trip_Obj?.iResult == 0" class="failed-container border-2 rounded p-md-3 px-2">
        <div class="alert alert-danger w-100 d-flex align-items-center justify-content-center" role="alert">
            <span class="fw-bold mx-1 fs-6" style="line-height: 30px;"> {{ trip_Obj?.strMessage }} </span>
        </div>

        <!-- توضیحات -->
        <div *ngIf="trip_Obj.iEmdadRo != -1" class="alert alert-danger w-100" role="alert">
            <p class="fw-bold mx-1 " style="font-size: 13px;">
                کد سفر : {{ trip_Obj.iEmdadRo || 'نامشخص' | faNum }}

            </p>

            <p class="fw-bold mx-1 " style="font-size: 13px;"> شماره تراکنش :
                {{ trip_Obj.strRefId || 'نامشخص' | faNum}}
                <i class="fa pointer" [ngClass]="bClipboard ? 'fa-check' : 'fa-clone' "
                    (click)="clipboard(trip_Obj.strRefId)">
                    {{ bClipboard ? 'کپی شد!' : '' }}
                </i>
            </p>

        </div>

    </section>

    <!-- درخواست‌های من -->
    <div class="d-flex justify-content-center mt-2 p-md-3 px-2 ">
        <button class="btn btn-primary text-dark w-100" routerLink="/all-request">
            درخواست‌های من
        </button>
    </div>
</main>